import { ContentCard } from "@/components/contentCard";

export const ENHANCEMENTS_CONSTANTS = {
  title: "Modern Enhancements That Set OneMind Apart",
  list: [
    {
      title: "MITRE ATT&CK Framework Alignment ",
      subTitle: "Understand threats not just by signature — but by strategy",
      content: (
        <ContentCard
          text=" OneMind aligns detections with the MITRE ATT&CK® framework, giving security teams clear visibility into adversary behavior, techniques, and attack stages. "
          points={[
            "Map vulnerabilities and threats to real-world TTPs",
            "Strengthen red/blue team exercises with contextual data",
            "Enhance threat response and compliance documentation",
          ]}
        />
      ),
    },
    {
      title: "Predictive Exploit Scoring",
      subTitle: "Don’t just detect risks — predict which will be weaponized.",
      content: (
        <ContentCard
          text="Our AI engine prioritizes vulnerabilities based on real-world exploitability, leveraging global threat intel and attack likelihood modeling."
          points={[
            "Automatically surface the most critical risks",
            "Reduce noise with behavior-weighted risk scoring",
            "Improve MTTD and MTTR with smarter triage",
          ]}
        />
      ),
    },
    {
      title: "Faster Time-to-Patch",
      subTitle: "Patch smarter. Patch faster. Patch before impact.",
      content: (
        <ContentCard
          text="OneMind reduces patch deployment time by up to 70%, ensuring your environment is protected before attackers can act."
          points={[
            "Zero-touch patching across OS and third-party apps",
            "No business interruption during updates",
            "Flexible scheduling based on asset sensitivity",
          ]}
        />
      ),
    },
    {
      title: "Expanded Asset Visibility",
      subTitle: "Secure every endpoint — not just the obvious ones.",
      content: (
        <ContentCard
          text="OneMind continuously scans across cloud, IoT, servers, and virtual environments, offering full visibility into modern, hybrid attack surfaces."
          points={[
            "Discover unmanaged and shadow assets",
            "Monitor risk across cloud-native, on-prem, and edge",
            "Build a complete inventory of exploitable surfaces",
          ]}
        />
      ),
    },
  ],
  concText: {
    label: "NOTE",
    text: " All of this is managed from a single intelligent console, combining detection, prioritization, orchestration, and compliance into one seamless experience.",
  },
};
